//search-keyword-api.js

import axios from 'axios';
import { API_URL } from '@/config/api.config';

const searchKeywordAPI = {
    /**
     * 获取搜索词列表
     */
    getSearchKeywordList: async () => {
        try {
            const response = await axios.get(`${API_URL}/search-keyword`);
            return response.data;
        } catch (error) {
            console.error('获取搜索词列表失败:', error);
            throw error;
        }
    },

    /**
     * 新增搜索词
     */
    createSearchKeyword: async (searchKeywordData) => {
        try {
            const response = await axios.post(`${API_URL}/search-keyword`, searchKeywordData);
            return response.data;
        } catch (error) {
            console.error('创建搜索词失败:', error);
            throw error;
        }
    },

    /**
     * 更新搜索词
     */
    updateSearchKeyword: async (id, searchKeywordData) => {
        try {
            const response = await axios.put(`${API_URL}/search-keyword/${id}`, searchKeywordData);
            return response.data;
        } catch (error) {
            console.error('更新搜索词失败:', error);
            throw error;
        }
    },

    /**
     * 删除搜索词
     */
    deleteSearchKeyword: async (id) => {
        try {
            const response = await axios.delete(`${API_URL}/search-keyword/${id}`);
            return response.data;
        } catch (error) {
            console.error('删除搜索词失败:', error);
            throw error;
        }
    },

    /**
     * 更新搜索词状态
     */
    updateKeywordStatus: async (id, isActive) => {
        try {
            const response = await axios.put(`${API_URL}/search-keyword/${id}/status`, { is_active: isActive });
            return response.data;
        } catch (error) {
            console.error('更新搜索词状态失败:', error);
            throw error;
        }
    },

    /**
     * 获取搜索词详情
     */
    getKeywordDetail: async (id) => {
        try {
            const response = await axios.get(`${API_URL}/search-keyword/${id}`);
            return response.data;
        } catch (error) {
            console.error('获取搜索词详情失败:', error);
            throw error;
        }
    },

    /**
     * 更新搜索词排序
     */
    reorderSearchKeyword: async (orderData) => {
        try {
            const response = await axios.put(`${API_URL}/search-keyword/reorder`, orderData);
            return response.data;
        } catch (error) {
            console.error('更新搜索词排序失败:', error);
            throw error;
        }
    },
};

export default searchKeywordAPI;